import { DOCUMENT, Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExternalLinkService {
  private readonly _document = inject(DOCUMENT);

  openInNewTab(url: string): void {
    this._document.defaultView?.open(url, '_blank', 'noopener,noreferrer');
  }

  copy(value: string): Promise<void> {
    return this._document.defaultView?.navigator?.clipboard?.writeText(value) ?? Promise.resolve();
  }
}
